var parts = ['container', 'track', 'thumb'];
var baseStyleTrack = function baseStyleTrack(props) {
  var c = props.colorScheme;
  return {
    borderRadius: 'full',
    p: '1px',
    width: 'var(--slider-track-width)',
    height: 'var(--slider-track-height)',
    transitionProperty: 'common',
    transitionDuration: 'fast',
    bg: 'white',
    border: "1px solid",
    _focus: {
      boxShadow: "0 0 2px"
    },
    _disabled: {
      cursor: 'not-allowed',
      bg: 'gray.100',
      borderColor: 'gray.300',
      '.chakra-switch__thumb': {
        borderColor: 'gray.300'
      }
    },
    _checked: {
      bg: "".concat(c, ".400")
    },
    _invalid: {
      bg: "white",
      borderColor: "red.400",
      '.chakra-switch__thumb': {
        borderColor: 'red.400'
      },
      _focus: {
        boxShadow: 'none'
      }
    }
  };
};
var baseStyleThumb = function baseStyleThumb(props) {
  props.colorScheme;
  return {
    bg: 'white',
    border: '1px',
    transitionProperty: 'transform',
    transitionDuration: 'normal',
    mt: '-2px',
    ml: '-2px',
    borderRadius: 'inherit',
    width: 'calc(var(--slider-track-height) + 4px)',
    height: 'calc(var(--slider-track-height) + 4px)',
    _checked: {
      transform: 'translateX(var(--slider-thumb-x))'
    }
  };
};
var baseStyle = function baseStyle(props) {
  var c = props.colorScheme;
  return {
    container: {
      '--slider-track-diff': 'calc(var(--slider-track-width) - var(--slider-track-height))',
      '--slider-thumb-x': 'var(--slider-track-diff)',
      _rtl: {
        '--slider-thumb-x': 'calc(-1 * var(--slider-track-diff))'
      },
      color: "".concat(c, ".400")
    },
    track: baseStyleTrack(props),
    thumb: baseStyleThumb(props)
  };
};
var sizes = {
  sm: {
    container: {
      '--slider-track-width': '1.5rem',
      '--slider-track-height': '0.875rem'
    }
  },
  md: {
    container: {
      '--slider-track-width': '2.25rem',
      '--slider-track-height': '1.25rem'
    }
  },
  lg: {
    container: {
      '--slider-track-width': '2.875rem',
      '--slider-track-height': '1.5rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Switch = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Switch as default };